import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function codigoPostalValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valor = control.value;
    const regex = /^[0-9]{5}$/; // Solo 5 dígitos
    if (!valor) {
      return null; // No validar si está vacío (se puede usar Validators.required aparte)
    }
    return regex.test(valor) ? null : { codigoPostalInvalido: true };
  };
}